export function generateAddress($object, withoutPrimaryAddress, $suffix)
{
    // This function generates a properly formatted address regardless of what data is or is not available
    // Not loaded in scope yet

    var $copy = {...$object};
    $suffix = typeof $suffix == "undefined" ? "" : $suffix;

    if(typeof $object == 'undefined' || !$object.hasOwnProperty('address'+$suffix))
    {
        return '';
    }

    var output = '';

    var checkAgainst = ["address"+$suffix, "address_2"+$suffix, "city"+$suffix, "state_province"+$suffix, "zip_postal"+$suffix, "country"+$suffix];
    for(var i = 0; i < checkAgainst.length; i++)
    {
        if($copy[checkAgainst[i]] == null)
        {
            $copy[checkAgainst[i]] = '';
        }
    }

    // Used for an address in mm-relationship (so that the _whole_ address doesn't get linked)
    withoutPrimaryAddress = withoutPrimaryAddress || false;

    // Address
    if(!withoutPrimaryAddress && $copy["address"+$suffix].length)
    {
        output += $copy["address"+$suffix];
    }

    if(!withoutPrimaryAddress && $copy["address"+$suffix].length
        && (
            $copy["address_2"+$suffix].length
            || $copy["city"+$suffix].length
            || $copy["state_province"+$suffix].length
            || $copy["zip_postal"+$suffix].length
            || $copy["country"+$suffix].length
        ))
    {
        output += '<br>';
    }

    // Address 2
    if($copy["address_2"+$suffix].length)
    {
        output += $copy["address_2"+$suffix];
    }

    if($copy["address_2"+$suffix].length
        && (
            $copy["city"+$suffix].length
            || $copy["state_province"+$suffix].length
            || $copy["zip_postal"+$suffix].length
            || $copy["country"+$suffix].length
        ))
    {
        output += '<br>';
    }

    // City, state, zip
    if($copy["city"+$suffix].length)
    {
        output += $copy["city"+$suffix];
    }

    if($copy["city"+$suffix].length && $copy["state_province"+$suffix].length)
    {
        output += ', ';
    }

    if($copy["state_province"+$suffix].length)
    {
        output += $copy["state_province"+$suffix];
    }

    if($copy["zip_postal"+$suffix].length && ($copy["city"+$suffix].length || $copy["state_province"+$suffix].length))
    {
        output += ' ';
    }

    if($copy["zip_postal"+$suffix].length)
    {
        output += $copy["zip_postal"+$suffix];
    }

    /*
    if($copy["country"+$suffix].length && ($copy["city"+$suffix].length || $copy["state_province"+$suffix].length || $copy["zip_postal"+$suffix].length))
    {
        output += '<br>';
    }

    /*
    if($copy["country"+$suffix].length)
    {
        output += $copy["country"+$suffix];
    }
    */

    return output;
};
